import { Component, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';

@Component({
  selector: 'app-pep',
  templateUrl: './pep.component.html',
  styleUrls: ['./pep.component.scss']
})
export class PepComponent  {

  constructor(private modalService: BoobleModalService) { }

  closeModal() {
    this.modalService.dismiss(null);
  }

}
